import { useEffect, useRef, useState } from "react";
import { SEARCH_DEBOUNCE_MS } from "../utils/constants";

// Generalizes the inline debounce pattern already used by
// src/adai/hooks/useHistoryData.js — returns `value` delayed by `delayMs`
// after the last change, so a fast typer doesn't fire one request per
// keystroke.
export function useDebouncedValue(value, delayMs = SEARCH_DEBOUNCE_MS) {
  const [debounced, setDebounced] = useState(value);
  const timerRef = useRef(null);

  useEffect(() => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timerRef.current);
  }, [value, delayMs]);

  return debounced;
}
